import React from 'react'
import { Route, Switch } from 'react-router'
import ReportVehicleProfits from './ReportVehicleProfits'

const Components = props => (
    <Switch>
        <Route exact path={`${props.match.url}/:year?`} component={ReportVehicleProfits} />
    </Switch>
)

export default Components
